export default "__VITE_ASSET__BTMdxdBg__"